import { DT } from '../../theme/designTokens';

interface Props {
  /** CSS margin shorthand. Default '36px 0'. */
  margin?: string;
}

/** 1px horizontal rule in DT.color.border. */
export function Divider({ margin = '36px 0' }: Props) {
  return (
    <div style={{ borderTop: `1px solid ${DT.color.border}`, margin }} />
  );
}
